import { useEffect, useState } from "react";
import Stack from '@mui/material/Stack';
import moment from 'moment-timezone';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useStoreContext } from "src/store/context";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useFSMapEndDate, useFSMapStartDate } from "src/store/actions";

/*To Do : Maybe store the other calls somewhere so we don't have to make same call if user is going back to the latest obesrvation*/
export default function FieldSampleDate() {

    const [state,dispatch] = useStoreContext();
    const [errorStartDateMsg, setErrorStartDateMsg] = useState<string|null>(null);
    const [errorEndDateMsg, setErrorEndDateMsg] = useState<string|null>(null);
    const setFSMapStartDate = useFSMapStartDate(dispatch);
    const setFSMapEndDate = useFSMapEndDate(dispatch);
    const [startDate, setStartDate] = useState<any>(state.fsMapStartDate);
    const [endDate, setEndDate] = useState<any>(state.fsMapEndDate);

    const handleStartDate = (newValue: any) => {
        if (!(newValue).isValid()) {
            setErrorStartDateMsg('Invalid Date');
            return;
        }
        setStartDate(moment(newValue))
        if(!localStorage.getItem('user') && (moment(newValue)<moment().subtract(1,'year').subtract(12,'hour'))){
          setErrorStartDateMsg('Must sign in')
        }
        else if((moment(newValue) <= moment(endDate))){
            if(errorEndDateMsg=== 'Invalid Date' || (moment()<=moment(startDate)) || moment()<=moment(endDate) || newValue=== 'Invalid Date'){
              return
            }
            else{
              if(!errorEndDateMsg){
                setErrorEndDateMsg(null)
              }
              if(errorEndDateMsg?.includes('before')){
                setErrorEndDateMsg(null)
                setFSMapEndDate(endDate.toISOString())
              }
              setErrorStartDateMsg(null)
              setFSMapStartDate(newValue.toISOString());
            }
          }
          else if(moment(newValue) > moment(endDate)) {
            setErrorStartDateMsg('Start Date is after End Date');
          }
          else{
            setErrorStartDateMsg('Invalid Date');
          }
    };

    const handleEndDate = (newValue: any) => {
        if (!(newValue).isValid()) {
            setErrorEndDateMsg('Invalid Date');
            return;
        };
        setEndDate(moment(newValue))
        if(!localStorage.getItem('user') && (moment(newValue)<moment().subtract(1,'year').subtract(12,'hour'))){
          setErrorEndDateMsg('Must sign in')
        }        
        else if((moment(newValue) >= moment(startDate))){
          if(errorStartDateMsg=== 'Invalid Date' || (moment()<=moment(startDate)) || (moment()<=moment(endDate)) || newValue=== 'Invalid Date'){
            return
          }
          else{
            if(!errorStartDateMsg){
              setErrorStartDateMsg(null)
            }
            if(errorStartDateMsg?.includes('after')){
              setErrorStartDateMsg(null);
              setFSMapStartDate(startDate.toISOString())
            }
            setFSMapEndDate(newValue.toISOString());
            setErrorEndDateMsg(null)
          }
        }
        else if(moment(newValue) < moment(startDate)){
          setErrorEndDateMsg('End Date is before Start Date');
        }
        else{
          setErrorEndDateMsg('Invalid Date');
        }
    };
    
    useEffect(()=>{
      if(!errorEndDateMsg && !errorStartDateMsg && (state.fsMapEndDate!==endDate)){
        setEndDate(state.fsMapEndDate);
      }
      if(!errorEndDateMsg && !errorStartDateMsg && (state.fsMapStartDate!==startDate)){
        setStartDate(state.fsMapStartDate);
      }
    },[state.fsMapEndDate, endDate, errorEndDateMsg, errorStartDateMsg, startDate, state.fsMapStartDate])

    useEffect(()=>{
      if(!errorEndDateMsg && !errorStartDateMsg && (state.fsMapEndDate!==endDate)){
        setEndDate(state.fsMapEndDate);
      }
      if(!errorEndDateMsg && !errorStartDateMsg && (state.fsMapStartDate!==startDate)){
        setStartDate(state.fsMapStartDate);
      }
    },[state.fsMapEndDate, endDate, errorEndDateMsg, errorStartDateMsg, startDate, state.fsMapStartDate])
    
    return (
        <div className="dateTimePicker">
            <Stack
                alignItems="center">
                <div className="dateFSPicker">'
                
                    <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>

                        {
                            <DatePicker
                                disableFuture
                                value={moment(startDate).tz(state.userTimeZone.id[0])}
                                slotProps={{
                                    textField: {
                                        id: "StartDate",
                                        error: errorStartDateMsg? true:false,
                                        helperText: errorStartDateMsg,
                                    },
                                }}
                                label='Start Date'
                                timezone={state.userTimeZone.id[0]}
                                onChange={(newValue) => { handleStartDate(newValue) }}
                                maxDate={!localStorage.getItem('user') && moment().add(1,'day')}
                                minDate={!localStorage.getItem('user') && moment().subtract(1,'year').subtract(12,'hour')}
                                onError={(reason)=>{
                                    if(reason === 'disableFuture'){
                                      setErrorStartDateMsg('Start Date is in the Future');
                                    }
                                    else if(reason ==='invalidDate'){
                                      setErrorStartDateMsg('Invalid Date');
                                    }
                                    else if(reason === null && moment(startDate) <= moment(endDate)){
                                      if(!errorEndDateMsg){
                                        setErrorEndDateMsg(null)
                                      }
                                      setErrorStartDateMsg(null);
                                    }
                                    else{
                                      if(moment(startDate) > moment(endDate)){
                                        setErrorStartDateMsg('Start Date is after End Date');
                                      }
                                      else{
                                        setErrorStartDateMsg('An Error on Start Date')
                                      }
                                    }}
                                }
                            />
                        }
                    </LocalizationProvider>
                    <div style={{paddingLeft: '3px', width: '100%'}}>
                    <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>

                        {
                            <DatePicker
                                
                                value={moment(endDate).tz(state.userTimeZone.id[0])}
                                slotProps={{
                                    textField: {
                                        id: "EndDate",
                                        error: errorEndDateMsg ? true : false,
                                        helperText: errorEndDateMsg,
                                    },
                                }}
                                label='End Date'
                                onChange={(newValue) => { handleEndDate(newValue) }}
                                maxDate={!localStorage.getItem('user') && moment().add(1,'day')}
                                minDate={!localStorage.getItem('user') && moment().subtract(1,'year').subtract(12,'hour')}
                                timezone={state.userTimeZone.id[0]}
                                onError={(reason)=>{
                                    if(reason ==='invalidDate'){
                                      setErrorEndDateMsg('Invalid Date');
                                    }
                                    else if(reason === null && moment(startDate) <= moment(endDate)){
                                      if(!errorStartDateMsg){
                                        setErrorStartDateMsg(null)
                                      }                
                                      setErrorEndDateMsg(null);
                                    }
                                    else{
                                      if(moment(endDate) < moment(startDate)){
                                        setErrorEndDateMsg('End Date is before Start Date');
                                      }
                                  }}}
                            />
                        }
                    </LocalizationProvider>
                    </div>
                </div>
            </Stack>
            {!localStorage.getItem('user') &&
              <div style={{ fontSize: '11px', fontStyle: "italic", textAlign: 'center' }}>Need more than a year of data? Please sign in</div>
            }
            <Stack direction="row" spacing={.5}>
                        {/*if they want buttons*/}
            </Stack>
        </div>

    );
}